// @ts-expect-error
import CollapseTransition from '@ivanv/vue-collapse-transition/src/CollapseTransition.vue';

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.component('CollapseTransition', CollapseTransition);
});
